import fetchWrapper from './fetchWrapper'

const API_URI = process.env.REACT_APP_ALTOON_API_URI

class BackendApis {
  async generateToken({ utmParams }) {
    try {
      const options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ utmParams }),
      }
      const res = await fetchWrapper(`${API_URI}/toons/generate-token-for-web`, options)
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async loadWebUserData() {
    try {
      const options = {
        method: 'GET',
      }
      const res = await fetchWrapper(`${API_URI}/toons/load-web-user-data`, options)
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async createDynamicLink() {
    try {
      const options = {
        method: 'GET',
      }
      const res = await fetchWrapper(`${API_URI}/toons/create-dynamic-link-for-web`, options)
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async loadBannerData() {
    try {
      const options = {
        method: 'GET',
      }
      const res = await fetchWrapper(`${API_URI}/toons/load-banner-data-for-web`, options)
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async loadAllToons() {
    try {
      const options = {
        method: 'GET',
      }
      const res = await fetchWrapper(`${API_URI}/toons/load-all-toons-for-web`, options)
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async loadTrendingToons() {
    try {
      const options = {
        method: 'GET',
      }
      const res = await fetchWrapper(`${API_URI}/toons/load-trending-toons-for-web`, options)
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async loadRecommendingToons(selectedGenres, recommendType) {
    try {
      const options = {
        method: 'GET',
      }
      const res = await fetchWrapper(
        `${API_URI}/toons/load-recommending-toons-for-web?selectedGenres=${selectedGenres}&recommendType=${recommendType}`,
        options
      )
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async loadToonDetail(toonId) {
    try {
      const options = {
        method: 'GET',
      }
      const res = await fetchWrapper(
        `${API_URI}/toons/load-toon-detail-for-web?toonId=${toonId}`,
        options
      )
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async loadToonChapterInfo(toonId, ascendingSort) {
    try {
      const options = {
        method: 'GET',
      }
      const res = await fetchWrapper(
        `${API_URI}/toons/load-toon-chapters-for-web?toonId=${toonId}&ascendingSort=${ascendingSort}`,
        options
      )
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async loadChapter(chapterId) {
    try {
      const options = {
        method: 'GET',
      }
      const res = await fetchWrapper(
        `${API_URI}/toons/load-chapter-for-web?chapterId=${chapterId}`,
        options
      )
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async loadChapterByEpisode(toonId, episode) {
    try {
      const options = {
        method: 'GET',
      }
      const res = await fetchWrapper(
        `${API_URI}/toons/load-chapter-episode-for-web?toonId=${toonId}&episode=${episode}`,
        options
      )
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async loadToonViewLog(toonId) {
    try {
      const options = {
        method: 'GET',
      }
      const res = await fetchWrapper(
        `${API_URI}/toons/load-view-log-for-web?toonId=${toonId}`,
        options
      )
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async logChapterViewed(toonId, chapterId, rentPeriod) {
    try {
      const options = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ toonId, chapterId, rentPeriod }),
      }
      const res = await fetchWrapper(`${API_URI}/toons/log-chapter-viewed-for-web`, options)
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async loadAllNovels() {
    try {
      const options = {
        method: 'GET',
      }
      const res = await fetchWrapper(`${API_URI}/toons/load-all-novels-for-web`, options)
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async loadNovelInfoById({ novelId }) {
    try {
      const options = {
        method: 'GET',
      }
      const res = await fetchWrapper(
        `${API_URI}/toons/load-novel-info-for-web?novelId=${novelId}`,
        options
      )
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async loadNovelDetail({ novelId }) {
    try {
      const options = {
        method: 'GET',
      }
      const res = await fetchWrapper(
        `${API_URI}/toons/load-novel-detail-for-web?novelId=${novelId}`,
        options
      )
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async loadToonEventInfo(eventId) {
    try {
      const options = {
        method: 'GET',
      }
      const res = await fetchWrapper(
        `${API_URI}/toons/load-toon-event-for-web?eventId=${eventId}`,
        options
      )
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async loadToonInfoByIds(toonIdList) {
    try {
      const options = {
        method: 'GET',
      }
      const res = await fetchWrapper(
        `${API_URI}/toons/load-toon-info-by-ids-for-web?toonIdList=${toonIdList}`,
        options
      )
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async loadNovelInfoByIds(novelIdList) {
    try {
      const options = {
        method: 'GET',
      }
      const res = await fetchWrapper(
        `${API_URI}/toons/load-novel-info-by-ids-for-web?novelIdList=${novelIdList}`,
        options
      )
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async loadLeaderboardInfo(eventId) {
    try {
      const options = {
        method: 'GET',
      }
      const res = await fetchWrapper(
        `${API_URI}/toons/load-leaderboard-for-web?eventId=${eventId}`,
        options
      )
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async updateLeaderboardInfo(eventId, score) {
    try {
      const options = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ eventId, score }),
      }
      const res = await fetchWrapper(`${API_URI}/toons/update-leaderboard-for-web`, options)
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async loadPollData(eventId) {
    try {
      const options = {
        method: 'GET',
      }
      const res = await fetchWrapper(
        `${API_URI}/toons/load-poll-data-for-web?eventId=${eventId}`,
        options
      )
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async submitPoll(eventId, toonId) {
    try {
      const options = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ eventId, toonId }),
      }
      const res = await fetchWrapper(`${API_URI}/toons/submit-poll-for-web`, options)
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }

  async participateLeaderboard(eventId) {
    try {
      const options = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ eventId }),
      }
      const res = await fetchWrapper(`${API_URI}/toons/participate-leaderboard-for-web`, options)
      const data = await res.json()
      return data
    } catch (err) {
      console.log(err)
    }
  }
}

export default new BackendApis()
